// eslint-disable-next-line monorepo/no-internal-import
import type {AuthMedium} from '@aboutyou/user/src/user-state/userStore/types';
import {sha256} from '../../../global-utils/helper-implementations/sha256';
import {TrackingPageContext} from '../../../types';

interface TrackAuthenticationEvent {
  event: 'login' | 'sign_up';
  label: AuthMedium;
  action: 'successful' | 'error';
  customer_id?: string;
  eh?: string;
  content_name: string;
  page_type: string;
  page_type_id: string;
}

export const trackAuthentication =
  ({
    label,
    action,
    customer_id,
    email,
    page,
    type,
  }: {
    type: 'login' | 'sign_up';
    label: AuthMedium;
    action: 'successful' | 'error';
    customer_id?: string;
    page: TrackingPageContext;
    email?: string;
  }) =>
  () => {
    const event: TrackAuthenticationEvent = {
      event: type,
      label,
      action,
      customer_id,
      eh: email ? sha256(email) : undefined,
      content_name: page.path,
      page_type: page.type,
      page_type_id: `${page.id || ''}`,
    };

    return event;
  };
